export default {"src":"/_next/static/media/pool.520abee0.svg","height":29,"width":32,"blurWidth":0,"blurHeight":0};